// TODO: klik na scrollbar nekdy odfokusne input a zavre SearchableSelect
// TODO: kdyz napisu rucne neco, co je v listu, ale nekliknu na to, nevybere se to

import $ from "jquery";
import {throttle, debounce, memoizeSimple as memoize} from "./framework/voidash";
import {addClass, removeClass, toggleClass} from "./utils";

function escapeRegExp(str) {
    return str.replace(/[\-\[\]\/{}()*+?.\\^$|]/g, "\\$&");
}

function fireEvent(el, eventName) {
    var event;
    if (typeof (Event) === 'function') {
        event = new Event(eventName, {
            view: window,
            bubbles: true,
            cancelable: true
        });
    } else if (typeof document.createEvent === 'function') {
        event = document.createEvent('Event');
        event.initEvent(eventName, true, true);
    } else {
        return false;
    }

    if (typeof el.fireEvent === 'function') {
        el.fireEvent('on' + eventName, event);
        return false;
    }

    el.dispatchEvent(event);
    return true;
}

function submitForm(form) {
    var i, el;

    // find first submit element
    for (i = 0; i < form.elements.length; i++) if ((el = form.elements[i]).type === 'submit') break;

    if (i === form.elements.length) { // not found
        fireEvent(form, 'submit');
        form.submit();
    } else el.click(); // found
}

function reverseChildren(el) {
    var arr = Array.prototype.slice.call(el.children);
    var frag = document.createDocumentFragment();
    for (var i = arr.length - 1; i >= 0; i--) frag.appendChild(arr[i]);
    el.appendChild(frag);
}

function replaceElementWithContents(el) {
    while (el.childNodes.length) el.parentNode.insertBefore(el.firstChild, el);
    el.parentNode.removeChild(el);
}

function replaceElementsWithContents(rootEl, tagName) {
    var iterator = document.createNodeIterator(rootEl, NodeFilter.SHOW_ELEMENT, null, false);
    var node;
    while ((node = iterator.nextNode())) {
        if (node.tagName === tagName) replaceElementWithContents(node);
    }
}

// pomocnik, aby se nepoustely blur a click handlery pres sebe
// Spusti jenom tu funkci fn, s jakou se .schedule(fn, pr) behem jednoho event-loopu
// zavolalo s nejvyssi prioritou pr.
function HandleOnce() {
    this.reset();
}

HandleOnce.prototype.reset = function () {
    this.callback = null;
    this.priority = 0;
    this.scheduled = false;
};

HandleOnce.prototype.perform = function () {
    this.callback();
    this.reset();
};

HandleOnce.prototype.schedule = function (callback, priority) {
    if (priority >= this.priority) {
        this.callback = callback;
        this.priority = priority;
        if (!this.scheduled) {
            var self = this;
            setTimeout(function () {
                self.perform();
            }, 0);
            this.scheduled = true;
        }
    }
};
//=============================================================================
var matchers = {
    phrase: function (query) {
        return diacriticsVariants(escapeRegExp(query));
    },
    word: function (query) {
        return query.split(/\s+/).filter(Boolean).map(function (str) {
            return diacriticsVariants(escapeRegExp(str));
        }).join("|");
    }
};
//=============================================================================
var defaultOptions = {
    /*
    required ... fetch, template
    optional... onSelect, itemClick, enterKey, selectEl (element to which the popup gets appended - disables hiding)
    */
    minCharacters: 2,
    keySelect: false,
    hoverSelect: false,
    hoverDeselect: false,
    inputDeselect: false,
    escapeKey: true,
    focusAfterMouseInteraction: true,
    onSubmit: 'submit', // possible values: set, set-close, submit, submit-close
    preventHover: false, // do not select hovered items, only those clicked (useful in combination with selectEl)
    matchMode: "word",
    itemLimit: Infinity
};

var getTemplate = memoize(function (id) {
    var tpl = new VOID.Template();
    tpl.addTemplate('base', document.getElementById(id).innerHTML);
    return tpl;
});

function firstElement(htmlString) {
    var dummy = document.createElement('div');
    dummy.innerHTML = htmlString;
    return dummy.children[0];
}

export function InputComplete(el, opts) {
    this.inputEl = el;

    this.options = Object.assign({}, defaultOptions, opts);
    if (this.options.itemClick === undefined) this.options.itemClick = this.options.onSubmit;
    if (this.options.enterKey === undefined) this.options.enterKey = this.options.onSubmit;

    this.template = getTemplate(this.options.template);

    this.el = firstElement(this.template.parse('base', {items: '<span id="itemsContainerLocator"></span>'}));
    if (el.getAttribute('data-autocomplete-target') && document.getElementById(el.getAttribute('data-autocomplete-target'))) {
        document.getElementById(el.getAttribute('data-autocomplete-target')).insertBefore(this.el, null);
    } else {
        el.parentNode.insertBefore(this.el, el.nextSibling);
    }
    var locator = document.getElementById('itemsContainerLocator');
    this.itemsEl = locator.parentNode;
    this.itemsEl.removeChild(locator);
    el.autocomplete = 'off';

    if (this.options.selectEl) VOID.utils.getElement(this.options.selectEl).appendChild(this.el);

    this.handleBlurOrClick = new HandleOnce();

    this.close();
    // this.closeTimeout = 0;
    this.list = [];
    this.selectedIndex = -1;
    this.lastValue = '';
    this.persistentValue = '';
    this.isWaiting = false;
    this.isDisplayedBelow = true;
    this.isFocused = false;

    this.fetchHandle = null;

    this.bindEvents();
}

InputComplete.prototype.open = function () {
    // clearTimeout(this.closeTimeout);
    // this.closeTimeout = 0;
    this.el.style.display = '';
    if (!this.isOpen) {
        this.updatePosition();
        this.isOpen = true;
        this.scrollSelectedIntoView();
    }
    return this;
};

InputComplete.prototype.close = function () {
    // clearTimeout(this.closeTimeout);
    // this.closeTimeout = 0;
    if (this.options.selectEl) return;
    this.el.style.display = 'none';
    this.isOpen = false;
    return this;
};

InputComplete.prototype.clear = function () {
    this.setItems(false);
    this.lastValue = '';
    this.persistentValue = '';
    this.select(-1, true);
    return this;
};

InputComplete.prototype.focus = function () {
    this.inputEl.focus();
    return this;
};

InputComplete.prototype.value = function () {
    return this.inputEl.value;
};

InputComplete.prototype.markWaiting = function (state) {
    toggleClass(this.el, 'waiting', state);
    toggleClass(this.inputEl, 'waiting', state);
    this.isWaiting = state;
    return this;
};

InputComplete.prototype.setValue = function (value) {
    this.inputEl.value = this.lastValue = value;
    return this;
};

InputComplete.prototype.submit = function () {
    if (this.inputEl.form) submitForm(this.inputEl.form);
    return this;
};

InputComplete.prototype.setDisabled = function(disabled) {
    this.inputEl.disabled = disabled;
};

InputComplete.prototype.createItemEl = function (item) {
    var self = this;
    var el = firstElement(this.template.parse('item', Object.assign({}, item, {content: item.html /*legacy*/})));
    item.el = el;
    el.addEventListener('mouseenter', function (evt) {
        return self.handleItemEnter(evt, item);
    });
    el.addEventListener('mousedown', function (evt) {
        return self.handleItemClick(evt, item);
    });
    return el;
};

InputComplete.prototype.setItems = function (list, data) {
    var prevSelectedIndex = this.selectedIndex;
    this.selectedIndex = -1;

    // this.isDisplayedBelow = true;

    this.itemsEl.innerHTML = '';
    if (this.options.onSelect && prevSelectedIndex >= 0) this.options.onSelect(null, {src: "setItems"});
    if (!list || !list.length) {
        this.list = [];
        this.close();
        if (this.options.onUpdate) this.options.onUpdate(this);
        return;
    }
    for (var i = 0; i < list.length; i++) {
        list[i].index = i;
        var itemEl = this.createItemEl(list[i]);
        if (i >= this.options.itemLimit) itemEl.style.display = "none";
        this.itemsEl.appendChild(itemEl);
    }

    if (!this.isDisplayedBelow) reverseChildren(this.itemsEl);

    if (data && data.query) this.hilite(data.query);

    if (this.isFocused) this.open();
    if (this.isOpen) this.updatePosition();
    this.list = list;

    if (this.options.onUpdate) this.options.onUpdate(this);
};

InputComplete.prototype.setItemLimit = function(newLimit) {
    this.options.itemLimit = newLimit;
    for (var i = 0; i < this.list.length; i++) {
        var item = this.list[i];
        item.el.style.display = (i >= this.options.itemLimit) ? "none" : "";
    }
    if(newLimit <= this.selectedIndex) this.select(-1);
};

InputComplete.prototype.itemLimitHit = function() {
    return this.list.length > this.options.itemLimit;
};

InputComplete.prototype.hilite = function (query) {
    // remove highlighting
    replaceElementsWithContents(this.itemsEl, "MARK");

    // add highlighting
    function childrenAreText(el) {
        for (var i = 0; i < el.childNodes.length; i++) {
            var childNode = el.childNodes[i];
            if (childNode.nodeType === Node.ELEMENT_NODE) return false;
        }
        return true;
    }

    function acceptNode(el) {
        return el.tagName !== "MARK" && childrenAreText(el) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }

    try {
        var regExp = new RegExp("(?<!&[^;]*)" + this.getMatchRegExpStr(htmlEntities(query)), "gi");

        var iterator = document.createNodeIterator(this.itemsEl, NodeFilter.SHOW_ELEMENT, {acceptNode}, false);

        var el;
        while ((el = iterator.nextNode())) {
            el.innerHTML = el.innerHTML.replace(regExp, "<mark>$&</mark>");
        }
    } catch(e) {
        console.warn("InputComplete: highlighting error", e);
    }
}

InputComplete.prototype.getMatchRegExpStr = function (query) {
    return matchers[this.options.matchMode](query);
};

InputComplete.prototype.sort = function (list, query) {
    if (query.length === 0) return list;

    var re = new RegExp(this.getMatchRegExpStr(query), "gi");
    var i, match;

    for (i = 0; i < list.length; i++) {
        var text = list[i].fulltext || list[i].text;
        match = re.exec(text);
        if (!match) continue;
        var index = match.index;
        var matches = text.match(re);
        list[i].priority = [index, -matches.join("").length, -matches.length, i];
    }

    list.sort(multiplePrioritySorter);
    return list;
};

InputComplete.prototype.filter = function (list, query) {
    var re = new RegExp(this.getMatchRegExpStr(query), "i");
    var out = [];
    for (var i = 0; i < list.length; i++) {
        var item = list[i];
        if (re.test(item.fulltext || item.text)) {
            out.push(Object.assign({}, item));
        }
    }
    return out;
};

/*InputComplete.prototype.scheduleClose = function() {
  var self = this;
  this.closeTimeout = setTimeout(function() { self.close(); }, 100);
};*/

InputComplete.prototype.sufficientLength = function () {
    return (this.inputEl.value.trim().length >= this.options.minCharacters)
        || (this.options.sufficientRE && this.options.sufficientRE.test(this.inputEl.value));
}

InputComplete.prototype.canBeOpen = function () {
    return this.sufficientLength() && this.isFocused;
};

InputComplete.prototype.scrollSelectedIntoView = function () {
    if (this.isOpen && this.selectedIndex >= 0) {
        var item = this.list[this.selectedIndex];
        if (this.el.scrollTop > item.el.offsetTop) {
            this.el.scrollTop = item.el.offsetTop;
        } else if (this.el.scrollTop < item.el.offsetTop + item.el.offsetHeight - this.el.clientHeight) {
            this.el.scrollTop = item.el.offsetTop + item.el.offsetHeight - this.el.clientHeight;
        }
    }
    return this;
};

InputComplete.prototype.select = function (index, setValue, source) {
    if (index >= this.list.length) {
        if ((this.list.length || this.isWaiting) && this.canBeOpen()) this.open();
        return this;
    } else if(index >= this.options.itemLimit) {
        return this;
    }
    if (this.selectedIndex >= 0) removeClass(this.list[this.selectedIndex].el, 'active');
    if (index >= 0) {
        this.open();
        var item = this.list[index];
        addClass(item.el, 'active');
        if (setValue) this.setValue(item.text);
        this.selectedIndex = index;

        if (source !== "hover") this.scrollSelectedIntoView();

        if (setValue && this.options.onSelect) this.options.onSelect(item, {src: "select"});
    } else {
        this.setValue(this.persistentValue);
        this.selectedIndex = -1;

        if (setValue && this.options.onSelect) this.options.onSelect(null, {src: "select"});
    }

    return this;
};

InputComplete.prototype.selectFirst = function (pred, setValue) {
    for (var i = 0; i < this.list.length; i++) {
        var item = this.list[i];
        if (pred(item)) return this.select(i, setValue);
    }
    return this.select(-1, setValue);
};

InputComplete.prototype.selectValue = function (value, setValue) {
    return this.selectFirst(item => item.value === value, setValue);
};

InputComplete.prototype.getSelectedItem = function () {
    return this.selectedIndex >= 0 ? this.list[this.selectedIndex] : null;
};

InputComplete.prototype.fetch = function (opts) {
    this.fetchHandle = this.options.fetch(this.inputEl.value.trim(), this, opts);
    return this;
};

InputComplete.prototype.abortFetch = function () {
    if (this.fetchHandle && this.fetchHandle.abort) this.fetchHandle.abort();
};

InputComplete.prototype.fetchIfAllowed = function (opts) {
    if (this.sufficientLength()) this.fetch(opts);
    else this.abortFetch();
    return this;
};

InputComplete.prototype.handleItemEnter = function (evt, item) {
    if (this.options.preventHover) return;
    this.select(item.index, this.options.hoverSelect, "hover");
};

InputComplete.prototype.handleItemClick = function (evt, item) {
    var self = this;

    if (this.options.resetOnBlur) {
        this.handleBlurOrClick.schedule(handleItemClick, 2);
    } else {
        handleItemClick();
    }

    function handleItemClick() {
        self.suppressNextLeave = true;
        if (self.options.focusAfterMouseInteraction) self.inputEl.focus();
        self.select(item.index, false);
        switch (self.options.itemClick) {
            case 'set':
                self.setValue(item.text);
                break;
            case 'submit':
                self.setValue(item.text);
                self.submit();
                break;
            case 'set-close':
                self.setValue(item.text);
                self.close();
                break;
            case 'submit-close':
                self.setValue(item.text);
                self.submit();
                self.close();
                break;
            case false:
                break;
        }
        if (self.options.onSelect) self.options.onSelect(item, {src: "click"});
    }

    evt.preventDefault();
    return false;
};

InputComplete.prototype.handleFocus = function () {
    this.isFocused = true;
    if (!this.isOpen && this.canBeOpen()) {
        if (this.list.length || this.isWaiting) this.open();
        else if (this.options.minCharacters === 0) this.fetch(); // if minCharacters is 0, fetch even here, in focus
    }
};

InputComplete.prototype.handleBlur = function () {
    if (this.suppressBlur) return;

    var self = this;

    if (this.options.resetOnBlur) {
        this.handleBlurOrClick.schedule(handleBlur, 1);
    } else {
        this.close();
        this.isFocused = false;
    }

    function handleBlur() {
        // if blur caused by node removal (eq. ajax), do nothing
        if (!document.body.contains(self.inputEl)) return;

        self.setValue("");
        self.setItems(false);
        self.isFocused = false;
    }
};

InputComplete.prototype.handleKeydown = function (evt) {
    var prevKey = this.isDisplayedBelow ? 38 : 40;
    var nextKey = this.isDisplayedBelow ? 40 : 38;

    if (evt.keyCode === prevKey) { // up
        this.select(this.selectedIndex - 1, this.options.keySelect);
        evt.preventDefault();
        return false;
    } else if (evt.keyCode === nextKey) { // down
        this.select(this.selectedIndex + 1, this.options.keySelect);
        evt.preventDefault();
        return false;
    } else if (evt.keyCode === 13 && this.isOpen) { // enter
        if (this.selectedIndex >= 0) {
            var item = this.list[this.selectedIndex];
            switch (this.options.enterKey) {
                case 'set':
                    this.setValue(item.text);
                    break;
                case 'submit':
                    this.setValue(item.text);
                    this.submit();
                    break;
                case 'set-close':
                    this.setValue(item.text);
                    this.close();
                    break;
                case 'submit-close':
                    this.setValue(item.text);
                    this.submit();
                    this.close();
                    break;
                case false:
                    break;
            }
            if (this.options.onSelect) this.options.onSelect(item, {src: "keydown"});

            evt.stopPropagation();
            evt.preventDefault();
            return false;
        } /*else if(this.list.length === 1) { // use enter for selection of single item even it is not selected
        this.select(0, true);
      }*/
    } else if (evt.keyCode === 27) { // escape
        if (this.options.escapeKey) {
            this.close();
            if (this.isOpen) evt.stopPropagation();
        }
    }
};

InputComplete.prototype.handleKeyup = function () {
    if (this.inputEl.value !== this.lastValue) {
        if (this.canBeOpen()) {
            this.fetch();
        } else {
            this.setItems(false);
            this.close();
            this.abortFetch();
        }
        this.lastValue = this.persistentValue = this.inputEl.value;

        if (this.options.inputDeselect && this.options.onSelect) this.options.onSelect(null, {src: "keyup"});
    }
};

InputComplete.prototype.updatePosition = function () {
    if (this.options.selectEl) return;

    var rect = this.inputEl.getBoundingClientRect();
    var availHeightOver = rect.top;
    var availHeightUnder = window.innerHeight - availHeightOver - this.inputEl.offsetHeight;
    var finalHeight;

    var el = this.el;
    el.style.minWidth = this.inputEl.offsetWidth + 'px';

    el.style.maxHeight = "0px"; // avoid scrollbars when measuring offsetLeft
    //this.el.style.left = this.inputEl.offsetLeft + 'px';
    el.style.maxHeight = "";

    function setHeight(availHeight) {
        if (availHeight >= el.offsetHeight) {
            finalHeight = el.offsetHeight;
            el.style.maxHeight = "";
        } else {
            finalHeight = availHeight;
            el.style.maxHeight = Math.floor(finalHeight) + 'px';
        }
    }

    var fitsBelow = el.offsetHeight <= availHeightUnder;
    var fitsAbove = el.offsetHeight <= availHeightOver;

    var displayBelow = fitsBelow || availHeightUnder >= availHeightOver;

    if (!this.isDisplayedBelow && fitsAbove) displayBelow = false;

    if (displayBelow) {
        setHeight(availHeightUnder);
        el.style.top = (this.inputEl.offsetTop + this.inputEl.offsetHeight) + 'px';
    } else {
        setHeight(availHeightOver);
        el.style.top = (this.inputEl.offsetTop - finalHeight) + 'px';
    }

    if (this.isDisplayedBelow !== displayBelow) reverseChildren(this.itemsEl);

    this.isDisplayedBelow = displayBelow;

    // scroll to beginning
    this.el.scrollTop = this.isDisplayedBelow ? 0 : 1e4;
};

InputComplete.prototype.handleLeave = function () {
    if (this.suppressNextLeave) this.suppressNextLeave = false;
    else if (this.options.hoverDeselect) this.select(-1, true);
};

InputComplete.prototype.handleMousedown = function () {
    this.suppressBlur = true;
};

InputComplete.prototype.handleMouseup = function () {
    if (this.options.focusAfterMouseInteraction) this.inputEl.focus();
    this.suppressBlur = false;
};

InputComplete.prototype.handleDocMousedown = function (evt) {
    if (this.options.selectEl) return;
    if (!this.el.contains(evt.target) && !this.inputEl.contains(evt.target)) {
        this.suppressBlur = false;
        if (this.isFocused) {
            if (document.activeElement === this.inputEl) this.inputEl.blur();
            else this.handleBlur();
        }
    }
};

InputComplete.prototype.handleResize = throttle(function () {
    if (this.isOpen) {
        this.updatePosition();
    }
});

InputComplete.prototype.bindEvents = function () {
    var self = this;

    // onfocus, onblur, protoze addEventListener je interceptnutej cimsi v jQuery
    this.inputEl.onfocus = function (evt) {
        return self.handleFocus(evt);
    };
    this.inputEl.onblur = function (evt) {
        return self.handleBlur(evt);
    };
    this.inputEl.addEventListener('keydown', function (evt) {
        return self.handleKeydown(evt);
    });
    this.inputEl.addEventListener('keyup', function (evt) {
        return self.handleKeyup(evt);
    });
    this.el.addEventListener('mouseleave', function (evt) {
        return self.handleLeave(evt);
    });
    this.el.addEventListener('mousedown', function (evt) {
        return self.handleMousedown(evt);
    });
    this.el.addEventListener('mouseup', function (evt) {
        return self.handleMouseup(evt);
    });
    window.addEventListener('mousedown', function (evt) {
        return self.handleDocMousedown(evt);
    });
    window.addEventListener('resize', function (evt) {
        self.handleResize(evt);
    });
};

InputComplete.defaultOptions = defaultOptions;

function multiplePrioritySorter(a, b) {
    var i = 0;

    if (!a.priority && !b.priority) return 0;
    else if (!a.priority) return 1;
    else if (!b.priority) return -1;

    while (i < a.priority.length - 1 && i < b.priority.length - 1 && a.priority[i] === b.priority[i]) i++;
    return a.priority[i] - b.priority[i];
}

var diacriticsRemovalMap = [
    "\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F",
    "\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181",
    "\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E",
    "\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779",
    "\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E",
    "\u0046\u24BB\uFF26\u1E1E\u0191\uA77B",
    "\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E",
    "\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D",
    "\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197",
    "\u004A\u24BF\uFF2A\u0134\u0248",
    "\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2",
    "\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780",
    "\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C",
    "\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4",
    "\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C",
    "\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754",
    "\u0051\u24C6\uFF31\uA756\uA758\u024A",
    "\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782",
    "\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784",
    "\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786",
    "\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244",
    "\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245",
    "\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72",
    "\u0058\u24CD\uFF38\u1E8A\u1E8C",
    "\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE",
    "\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762",
    "\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250",
    "\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253",
    "\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184",
    "\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A",
    "\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD",
    "\u0066\u24D5\uFF46\u1E1F\u0192\uA77C",
    "\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F",
    "\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265",
    "\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131",
    "\u006A\u24D9\uFF4A\u0135\u01F0\u0249",
    "\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3",
    "\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747",
    "\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F",
    "\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5",
    "\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275",
    "\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755",
    "\u0071\u24E0\uFF51\u024B\uA757\uA759",
    "\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783",
    "\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B",
    "\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787",
    "\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289",
    "\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C",
    "\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73",
    "\u0078\u24E7\uFF58\u1E8B\u1E8D",
    "\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF",
    "\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
];

function diacriticsVariants(str) {
    var out = "";

    for (var i = 0; i < str.length; i++) {
        var chr = str[i];

        found: {
            for (var j = 0; j < diacriticsRemovalMap.length; j++) {
                var variants = diacriticsRemovalMap[j];

                if (variants.indexOf(chr) >= 0) {
                    out += "[" + variants + "]";
                    break found;
                }
            }

            out += chr;
        }
    }

    return out;
}

InputComplete.Static = function (list) {
    var out = function (query, inst) {
        if (query) {
            var res = inst.sort(inst.filter(list, query), query);
            inst.setItems(res, {query: query});
        } else {
            inst.setItems(list);
        }
    };

    out.setList = function (newList) {
        list = newList;
    };

    return out;
};

InputComplete.SelectElement = function (select) {
    var list = [];
    for (var i = 0; i < select.options.length; i++) {
        var option = select.options[i];
        if (!option.hidden && !option.disabled) {
            list.push({
                text: option.innerText,
                html: option.innerHTML,
                value: option.value
            });
        }
    }
    return InputComplete.Static(list);
};

InputComplete.AJAX = function (url, processFunction) {
    var maxTimestamp = 0;
    var waiting = 0;
    var callback = null;

    function doIt(query, inst, timestamp) {
        var xhr = new XMLHttpRequest();

        inst.markWaiting(true);
        waiting++;

        xhr.onreadystatechange = function () {
            if (xhr.readyState !== XMLHttpRequest.DONE) return;

            if (--waiting === 0) inst.markWaiting(false);

            if (timestamp < maxTimestamp) return; // update only if this request is newer than the last applied one

            if (xhr.status === 200) {
                maxTimestamp = timestamp;

                var list;
                try {
                    list = JSON.parse(xhr.responseText);
                    if (processFunction) list = processFunction(list, query, inst);
                } catch (e) {
                    list = null;
                    console.error(e);
                } finally {
                    inst.setItems(list, {query: query});
                    if (callback) callback(list);
                }
            }
        };

        xhr.open('GET', url + encodeURIComponent(query), true);
        xhr.send();
    }

    var debounced = debounce(doIt, 500);
    var immediate = debounce(doIt, 0);

    function out(query, inst, opts) {
        var timestamp = Date.now();

        if (opts && opts.immediate) immediate.call(this, query, inst, timestamp);
        else debounced.call(this, query, inst, timestamp);

        return {
            abort: function () {
                maxTimestamp = Date.now();
            }
        };
    }

    out.setUrl = function (newUrl) {
        url = newUrl;
    };
    out.setCallback = function (newCallback) {
        callback = newCallback;
    };

    return out;
};

var CachedAJAXShare = {};

InputComplete.CachedAJAX = function (url, processFunction) {
    function set(query, inst) {
        inst.setItems(CachedAJAXShare[url] && inst.sort(inst.filter(CachedAJAXShare[url], query), query), {query: query});
    }

    function doIt(query, inst) {
        if (!CachedAJAXShare[url] && url) {
            var xhr = new XMLHttpRequest();

            inst.markWaiting(true);

            xhr.onreadystatechange = function () {
                if (xhr.readyState !== XMLHttpRequest.DONE) return;

                inst.markWaiting(false);

                if (xhr.status === 200) {
                    try {
                        CachedAJAXShare[url] = JSON.parse(xhr.responseText);
                        if (processFunction) CachedAJAXShare[url] = processFunction(CachedAJAXShare[url], query, inst);
                    } catch (e) {
                        CachedAJAXShare[url] = null;
                        console.error(`CachedAJAX: Error when processing url ${url}`, xhr.responseText, e);
                    } finally {
                        set(query, inst);
                    }
                }
            };

            xhr.open('GET', url, true);
            xhr.send();
        } else {
            set(query, inst);
        }
    }

    doIt.setUrl = function (newUrl) {
        url = newUrl;
    };

    return doIt;
};

/*function parseGMapsJSON(obj) {
  var res = [];
  for(var i = 0; i < obj.results.length; i++) {
    res.push({
      text: obj.results[i].formatted_address,
      html: '<b>' + obj.results[i].formatted_address + '</b> <i>(' + obj.results[i].types.join(', ') + ')</i>'
    });
  }
  return res;
}

InputComplete.GMaps = function(api_key) {
  return InputComplete.AJAX('https://maps.googleapis.com/maps/api/geocode/json?key=' + api_key + '&components=country:CZ&address=', parseGMapsJSON);
};*/
//=============================================================================
// legacy
export function selectComplete(el, opts) {
    console.warn("selectComplete is deprcated. Use SelectComplete constrictor directly.");
    return new SelectComplete(el, opts);
}

export function SelectComplete(el, opts) {
    // save the default value
    var defaultOpt = el.options[Math.max(el.selectedIndex, 0)];
    var defaultVal = defaultOpt ? defaultOpt.value : "";
    var defaultTxt = defaultOpt ? defaultOpt.innerText : "";

    // actual displayed input
    var inputEl = document.createElement("input");
    inputEl.type = "text";

    // copy styles and insert it
    inputEl.className = el.className;
    inputEl.id = el.id;
    inputEl.disabled = el.disabled;
    el.removeAttribute("id");
    if (defaultOpt && (defaultOpt.hidden || defaultOpt.disabled || !defaultVal)) inputEl.placeholder = defaultTxt;
    else inputEl.value = defaultTxt;
    inputEl.type = "text";
    inputEl.required = opts.hasOwnProperty("required") ? opts.required : el.required;
    inputEl.autocomplete = "off";
    el.parentNode.insertBefore(inputEl, el.nextSibling);

    function markValid() {
        addClass(inputEl, "valid");
        if (opts.validate) inputEl.setCustomValidity("");
    }

    function markInvalid() {
        removeClass(inputEl, "valid");
        if (opts.validate) inputEl.setCustomValidity(inputEl.title || "invalid");
    }

    var isValid = !el.required || !!defaultVal;

    function validate() {
        if (isValid) markValid();
        else markInvalid();
    }

    var validateOnChange = !el.form || !el.form.noValidate;
    if (!validateOnChange) {
        el.form.addEventListener("submit", function () {
            validate();
        });
    }

    // hide the original input retaining its validability
    el.style.position = "absolute";
    el.style.opacity = 0.01;
    el.style.zIndex = -1;
    el.tabIndex = "-1";

    var prevItem = null;

    function handleSelect(item, meta) {
        if (item) {
            // non-empty selection
            if (!el.namedItem(item.value)) {
                // original select doesn't have corresponding item; create it
                var optEl = document.createElement("option");
                optEl.value = item.value;
                optEl.setAttribute("name", item.value); // set name to value, so we can use namedItem to query it
                optEl.innerText = item.text;
                el.add(optEl);
            }
            el.value = item.value; // select the corresponding value in original select
            isValid = true;
            markValid();
        } else {
            // empty selection
            el.selectedIndex = -1;
            isValid = !el.required;
            markInvalid();
        }
        if (el.onchange && prevItem !== item) el.onchange();
        if (opts.onSelect) opts.onSelect(item, meta); // proxy the given callback
        prevItem = item;
    }

    var icOptions = Object.assign({
        resetOnBlur: true,
        inputDeselect: true,
        validate: true
    }, opts, {onSelect: handleSelect});
    this.selectEl = el;
    this.inputEl = inputEl;

    var self = this;
    this.selectItem = function (item) {
        if (item) {
            self.selectedIndex = -1; // prevent onSelect call
            self.setItems([item]);
            self.selectedIndex = 0;
            self.setValue(item.text);
            handleSelect(item);
        } else {
            self.setItems(null);
            self.selectedIndex = -1;
            self.setValue("");
            handleSelect(null);
        }
    };

    InputComplete.call(this, inputEl, icOptions);
}

SelectComplete.prototype = Object.create(InputComplete.prototype);
SelectComplete.prototype.constructor = SelectComplete;

SelectComplete.prototype.handleResize = function (evt) {
    InputComplete.prototype.handleResize.call(this, evt);
    // this.selectEl.style.left = this.inputEl.offsetLeft + "px";
    // this.selectEl.style.top = this.inputEl.offsetTop + "px";
    this.selectEl.style.width = this.inputEl.offsetWidth + "px";
    this.selectEl.style.height = this.inputEl.offsetHeight + "px";
};

SelectComplete.prototype.value = function () {
    return this.selectEl.value;
};

SelectComplete.prototype.text = function () {
    return InputComplete.prototype.value.call(this);
};

SelectComplete.prototype.update = function () {
    var idx = this.selectEl.selectedIndex;
    if (idx >= 0) {
        var option = this.selectEl.options[idx];
        this.selectItem({
            text: option.innerText,
            html: option.innerHTML,
            value: option.value
        });
    }
};

//=============================================================================

export var SearchableSelect = VOID.View.extend({
    getName: VOID.utils.constant("searchable_select"),
    getTemplateName: VOID.utils.constant("searchable_select"),

    init: function() {
        this.registerSubview(new VOID.BasicView("", this.opts), "empty_list");
    },

    handleMounted: function () {
        var self = this;

        var select = this.opts.select;
        var $select = $(select);
        var defaultOpt = select.options[Math.max(select.selectedIndex, 0)];
        var defaultVal = defaultOpt.value;
        this.defaultTxt = defaultOpt.innerText;

        this.references.item.innerText = this.defaultTxt;
        if ($select.hasClass("active")) $(this.references.item).addClass("active");
        if(this.opts.additionalClass) $(this.references.item).addClass(this.opts.additionalClass);

        var dropdownCloseTimeout = 0;
        var isOpen = false;
        var isOpening = false;
        var selectedItem;

        function open(value) {
            clearTimeout(dropdownCloseTimeout);
            if(isOpen) return;
            $(self.references.dropdown).removeClass("d-none");
            if (value == null) {
                var item = selectedItem;
                value = item ? item.value : undefined;
            }
            isOpening = true;
            autocomplete
              .setValue("")
              .fetch({immediate: true})
              .selectValue(value, true)
              .scrollSelectedIntoView()
              .setValue("")
              .focus();
            isOpening = false;
            isOpen = true;

            return self;
        }

        this.open = this.focus = open;

        function close() {
            dropdownCloseTimeout = setTimeout(function () {
                $(self.references.dropdown).addClass("d-none");
                isOpen = false;
            }, 0);
        }

        this.close = close;

        $(select).on("focus", () => { this.focus(); });

        var autocomplete = this.autocomplete = new InputComplete(this.references.search_input, Object.assign({}, this.opts.searchOpts, {
            selectEl: this.references.search_results,
            onSelect: function (item, meta) {
                selectedItem = item;
                if (item) {
                    self.references.item.innerText = item.text;
                    if (meta.src === "click") close();
                    if (!isOpening) {
                        close(); // always close on select as if onSubmit: 'set-close' was set on inputComplete

                        if (!$select.children(`[value="${item.value}"]`).length) {
                            $(document.createElement("option"))
                              .attr("value", item.value)
                              .text(item.text)
                              .appendTo($select);
                        }

                        $select.val(item.value).trigger("change");
                        if (self.opts.onSelect) self.opts.onSelect(self.getSelectedItem());
                    }
                }
                if (self.opts.searchOpts.onSelect) self.opts.searchOpts.onSelect(item, meta);
            },
            onUpdate: () => {
                this.subviews.empty_list[0].setHTML(autocomplete.list.length ? "" : this.opts.template.parse("empty_list"));
                if (self.opts.searchOpts.onUpdate) self.opts.searchOpts.onUpdate(item, meta);
            }
        }));

        autocomplete.fetchIfAllowed({immediate: true});
        autocomplete.selectValue(defaultVal);
        selectedItem = autocomplete.getSelectedItem();

        $(this.references.search_input).on("keydown", function ($evt) {
            if ($evt.originalEvent.keyCode === 27) {
                close();
            }
        });

        this.references.item.addEventListener("mousedown", function (evt) {
            if (isOpen) {
                close();
            } else {
                open();
            }
            evt.preventDefault();
        });

        this.references.item.addEventListener("mouseup", function (evt) {
            evt.preventDefault();
        });

        this.references.el.addEventListener("focusin", function () {
            open();
        });

        this.references.el.addEventListener("focusout", function () {
            close();
        });
    },

    reset() {
        this.references.item.innerText = this.defaultTxt;
        this.opts.select.value = "";
        this.autocomplete.setValue("");
    },

    update: function () {
        this.autocomplete.selectValue(this.opts.select.value, true);
    },

    setItems: function(...args) {
        this.callNowOrOnMount(() => { this.autocomplete.setItems(...args); });
    },

    selectValue: function(...args) {
        const [value] = args;
        this.callNowOrOnMount(() => {
            this.autocomplete.selectValue(...args);
        });
    },

    value: function() {
        return this.opts.select.value;
    },

    getSelectedItem() {
        return this.autocomplete.getSelectedItem();
    },

    select: function(...args) {
        this.callNowOrOnMount(() => { this.autocomplete.select(...args); });
    },

    selectItem: function(item) {
        var autocomplete = this.autocomplete;
        if (item) {
            autocomplete.setItems([item]);
            autocomplete.select(0, true);
        } else {
            autocomplete.setItems(null);
            autocomplete.select(-1, true);
        }
    },

    setDisabled: function(state) {
        $(this.references.el).toggleClass("disabled", state);
    }
});

export function initSearchableSelect(opts) {
    var select = opts.select;
    var $select = $(select);

    if ($select.data("searchableSelect")) return;

    var view = new SearchableSelect(null, opts);

    // $(select).addClass("d-none"); // don't, disables focus
    $select.addClass("hidden").data("searchableSelect", view);
    view.insertBefore(select);

    return view;
}

//=============================================================================

export function initSelectComplete(opts) {
    var selects = document.querySelectorAll("select.searchable");
    for (var i = 0; i < selects.length; i++) {
        var select = selects[i];
        if (select._selectComplete) continue;

        /*select._selectComplete = new SelectComplete(select, Object.assign({
          fetch: InputComplete.SelectElement(select),
          template: "autocompleteTemplate",
          onSubmit: "set-close",
          minCharacters: 0
        }, opts || {}));*/

        var optsFinal = {
            select: select,
            template: "searchableSelectTemplate",
            searchOpts: {
                fetch: InputComplete.SelectElement(select),
                template: "autocompleteTemplate",
                onSubmit: "set-close",
                minCharacters: 0
            }
        };

        var searchOptsFinal = opts ? Object.assign({}, optsFinal.searchOpts, opts.searchOpts || {}) : optsFinal.searchOpts;
        optsFinal = Object.assign({}, optsFinal, opts, { searchOpts: searchOptsFinal });

        var searchableSelect = initSearchableSelect(optsFinal);

        select._selectComplete = searchableSelect;
    }
}
